import { Navigate, Route, Routes } from "react-router";
import { useSession } from "./lib/session";
import { useTill } from "./lib/till-context";
import { Layout } from "./components/Layout";
import { Spinner } from "./components/ui";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Products } from "./pages/Products";
import { StockMoves } from "./pages/StockMoves";
import { Customers } from "./pages/Customers";
import { Staff } from "./pages/Staff";
import { Reports } from "./pages/Reports";
import { Settings } from "./pages/Settings";
import { Team } from "./pages/Team";
import { Join } from "./pages/Join";
import { OwedPage, StockHealthPage } from "./components/Insights";

/** The shop's back office: sign in with a store admin account, then the pages. No selling here. */
export function App() {
  const s = useSession();
  const { me, loading } = useTill();
  // An invite link works signed out: the person sets their password there.
  const join = window.location.pathname.match(/^\/join\/([A-Za-z0-9]+)/);
  if (join && !s.token) return <Join code={join[1]!} />;
  if (!s.token) return <Login />;
  if (loading || !me)
    return (
      <div className="grid h-full place-items-center">
        <Spinner />
      </div>
    );
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="products" element={<Products />} />
        <Route path="stock" element={<StockMoves />} />
        <Route path="customers" element={<Customers />} />
        <Route path="staff" element={<Staff />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings />} />
        <Route path="team" element={<Team />} />
        <Route path="owed" element={<OwedPage />} />
        <Route path="health" element={<StockHealthPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
